import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="16" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14 2.25h-.75V.75h-1.5v1.5h-7.5V.75h-1.5v1.5H2c-.825 0-1.5.675-1.5 1.5v12c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-12c0-.825-.675-1.5-1.5-1.5zm0 13.5H2V7.5h12v8.25zM14 6H2V3.75h12V6z" fill="#444" /></svg>;